import { toItem } from '../mappers/item';
export function parseItems(res) {
  let cursor;
  if (res.data.paging && res.data.paging.cursors) {
    cursor = res.data.paging.cursors.after;
  }
  res.data = (res.data.data || []).map(toItem);
  res.paging = {
    cursor: cursor || null,
    size: null
  };
  return res;
}